import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class ResourceStatusEndpointService {
  readonly #service = inject(ServicesService);

  groupResourceStatus(groupCode: string, arrangementCode: string) {
    return this.#service.thip(
      `arrangement/${arrangementCode}/resource/status/group/${groupCode}`,
    );
  }

  storeResourceStatus(arrangementCode: string) {
    return this.#service.thip(`arrangement/${arrangementCode}/resource/status`);
  }
}
